import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../../src/assets/logo.svg'

const Footer = () => {
    return (
        <footer className="footer grid lg:grid-cols-4 grid-cols-2 p-10 bg-base-200 text-base-content">
            <div>
                <Link to='/'><img className='lg:w-64 w-32' src={logo} alt="" /></Link>
                <p>Buy & Sell<br />Copyright © Since 2020</p>
            </div>
            <div>
                <span className="footer-title">Services</span>
                <a className="link link-hover">Branding</a>
                <a className="link link-hover">Design</a>
                <a className="link link-hover">Marketing</a>
                <a className="link link-hover">Advertisement</a>
            </div>
            <div>
                <span className="footer-title">Company</span>
                <a className="link link-hover">About us</a>
                <a className="link link-hover">Contact</a>
                <a className="link link-hover">Jobs</a>
                <a className="link link-hover">Press kit</a>
            </div>
            <div>
                <span className="footer-title">Legal</span>
                <a className="link link-hover">Terms of use</a>
                <a className="link link-hover">Privacy policy</a>
                <a className="link link-hover">Cookie policy</a>
            </div>
        </footer>
    );
};

export default Footer;